import styles from './Hero.module.css'

const Hero = ({
  backgroundImage,
  backgroundVideo,
  title = "We are your",
  highlightText = "HVAC Experts",
  subtitle = "Design | Installation | Maintenance",
  ctaText = "Learn More",
  onCtaClick
}) => {
  const handleCtaClick = () => {
    if (onCtaClick) {
      onCtaClick()
    } else {
      const nextSection = document.getElementById('about')
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <section
      className={styles.hero}
      style={backgroundImage && !backgroundVideo ? { backgroundImage: `url(${backgroundImage})` } : {}}
    >
      {backgroundVideo && (
        <video
          className={styles.videoBg}
          autoPlay
          muted
          loop
          playsInline
          poster={backgroundImage}
        >
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      )}

      <div className={styles.overlay} />

      <div className={styles.content}>
        <h1 className={styles.title}>
          {title}
          <span className={styles.highlight}>{highlightText}</span>
        </h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>

      <button
        className={styles.ctaButton}
        onClick={handleCtaClick}
        aria-label={ctaText}
      >
        <span className={styles.ctaText}>{ctaText}</span>
        <span className={styles.ctaArrow}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M7 7L17 17" />
            <path d="M17 7L17 17L7 17" />
          </svg>
        </span>
      </button>
    </section>
  )
}

export default Hero
